import { Loan } from '../types/loan'

export const mockLoans: Loan[] = [
  {
    id: 'L-1001',
    borrowerName: 'James Smith',
    loanAmount: 450000,
    interestRate: 7.25,
    closeDate: '2023-05-15',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'james.smith@example.com',
    phone: '555-0101',
  },
  {
    id: 'L-1002',
    borrowerName: 'Maria Garcia',
    loanAmount: 320000,
    interestRate: 6.875,
    closeDate: '2022-11-20',
    loanTerm: 360,
    propertyType: 'Condo',
    email: 'maria.g@example.com',
    phone: '555-0102',
  },
  {
    id: 'L-1003',
    borrowerName: 'Robert Johnson',
    loanAmount: 650000,
    interestRate: 8.125,
    closeDate: '2023-08-10',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'robert.j@example.com',
    phone: '555-0103',
  },
  {
    id: 'L-1004',
    borrowerName: 'Linda Williams',
    loanAmount: 275000,
    interestRate: 5.5,
    closeDate: '2021-04-05',
    loanTerm: 180,
    propertyType: 'Townhouse',
    email: 'linda.w@example.com',
    phone: '555-0104',
  },
  {
    id: 'L-1005',
    borrowerName: 'Michael Brown',
    loanAmount: 510000,
    interestRate: 7.5,
    closeDate: '2023-02-28',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'michael.b@example.com',
    phone: '555-0105',
  },
  {
    id: 'L-1006',
    borrowerName: 'Elizabeth Jones',
    loanAmount: 425000,
    interestRate: 6.25,
    closeDate: '2022-07-12',
    loanTerm: 360,
    propertyType: 'Condo',
    email: 'elizabeth.j@example.com',
    phone: '555-0106',
  },
  {
    id: 'L-1007',
    borrowerName: 'William Davis',
    loanAmount: 780000,
    interestRate: 8.5,
    closeDate: '2023-10-05',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'william.d@example.com',
    phone: '555-0107',
  },
  {
    id: 'L-1008',
    borrowerName: 'Barbara Miller',
    loanAmount: 350000,
    interestRate: 5.875,
    closeDate: '2021-09-18',
    loanTerm: 360,
    propertyType: 'Townhouse',
    email: 'barbara.m@example.com',
    phone: '555-0108',
  },
  {
    id: 'L-1009',
    borrowerName: 'Richard Wilson',
    loanAmount: 590000,
    interestRate: 7.75,
    closeDate: '2023-06-22',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'richard.w@example.com',
    phone: '555-0109',
  },
  {
    id: 'L-1010',
    borrowerName: 'Susan Moore',
    loanAmount: 290000,
    interestRate: 6.5,
    closeDate: '2022-03-15',
    loanTerm: 180,
    propertyType: 'Condo',
    email: 'susan.m@example.com',
    phone: '555-0110',
  },
  {
    id: 'L-1011',
    borrowerName: 'Joseph Taylor',
    loanAmount: 480000,
    interestRate: 7.125,
    closeDate: '2023-01-10',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'joseph.t@example.com',
    phone: '555-0111',
  },
  {
    id: 'L-1012',
    borrowerName: 'Jessica Anderson',
    loanAmount: 620000,
    interestRate: 8.25,
    closeDate: '2023-09-30',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'jessica.a@example.com',
    phone: '555-0112',
  },
  {
    id: 'L-1013',
    borrowerName: 'Thomas Thomas',
    loanAmount: 310000,
    interestRate: 5.75,
    closeDate: '2021-11-05',
    loanTerm: 360,
    propertyType: 'Townhouse',
    email: 'thomas.t@example.com',
    phone: '555-0113',
  },
  {
    id: 'L-1014',
    borrowerName: 'Sarah Jackson',
    loanAmount: 540000,
    interestRate: 7.875,
    closeDate: '2023-07-14',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'sarah.j@example.com',
    phone: '555-0114',
  },
  {
    id: 'L-1015',
    borrowerName: 'Charles White',
    loanAmount: 410000,
    interestRate: 6.75,
    closeDate: '2022-08-25',
    loanTerm: 360,
    propertyType: 'Condo',
    email: 'charles.w@example.com',
    phone: '555-0115',
  },
  {
    id: 'L-1016',
    borrowerName: 'Karen Harris',
    loanAmount: 720000,
    interestRate: 8.75,
    closeDate: '2023-11-12',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'karen.h@example.com',
    phone: '555-0116',
  },
  {
    id: 'L-1017',
    borrowerName: 'Christopher Martin',
    loanAmount: 380000,
    interestRate: 6.125,
    closeDate: '2022-01-20',
    loanTerm: 360,
    propertyType: 'Townhouse',
    email: 'chris.m@example.com',
    phone: '555-0117',
  },
  {
    id: 'L-1018',
    borrowerName: 'Nancy Thompson',
    loanAmount: 560000,
    interestRate: 7.625,
    closeDate: '2023-04-08',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'nancy.t@example.com',
    phone: '555-0118',
  },
  {
    id: 'L-1019',
    borrowerName: 'Daniel Garcia',
    loanAmount: 295000,
    interestRate: 5.99,
    closeDate: '2021-12-15',
    loanTerm: 180,
    propertyType: 'Condo',
    email: 'daniel.g@example.com',
    phone: '555-0119',
  },
  {
    id: 'L-1020',
    borrowerName: 'Lisa Martinez',
    loanAmount: 495000,
    interestRate: 7.375,
    closeDate: '2023-03-22',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'lisa.m@example.com',
    phone: '555-0120',
  },
  {
    id: 'L-1021',
    borrowerName: 'Paul Robinson',
    loanAmount: 680000,
    interestRate: 8.375,
    closeDate: '2023-10-28',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'paul.r@example.com',
    phone: '555-0121',
  },
  {
    id: 'L-1022',
    borrowerName: 'Betty Clark',
    loanAmount: 330000,
    interestRate: 6.375,
    closeDate: '2022-05-10',
    loanTerm: 360,
    propertyType: 'Townhouse',
    email: 'betty.c@example.com',
    phone: '555-0122',
  },
  {
    id: 'L-1023',
    borrowerName: 'Mark Rodriguez',
    loanAmount: 525000,
    interestRate: 7.99,
    closeDate: '2023-08-05',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'mark.r@example.com',
    phone: '555-0123',
  },
  {
    id: 'L-1024',
    borrowerName: 'Sandra Lewis',
    loanAmount: 440000,
    interestRate: 6.875,
    closeDate: '2022-09-15',
    loanTerm: 360,
    propertyType: 'Condo',
    email: 'sandra.l@example.com',
    phone: '555-0124',
  },
  {
    id: 'L-1025',
    borrowerName: 'Donald Lee',
    loanAmount: 750000,
    interestRate: 9.125,
    closeDate: '2024-01-10',
    loanTerm: 360,
    propertyType: 'Single Family',
    email: 'donald.l@example.com',
    phone: '555-0125',
  },
]
